import { Mapper } from "../../../../base/utils/mapper";
import { ElectrocardiogramRhythmModel } from "../../../../domain/models/consult/electrocardiogram-rhythm.model";
import { ElectrocardiogramWavesModel } from "../../../../domain/models/consult/electrocardiogram-waves.model";
import { ElectrocardiogramWavesEntity } from '../entities/electrocardiogram-waves.entity';



export class ElectrocardiogramWavesRepositoryMapper extends Mapper<ElectrocardiogramWavesEntity, ElectrocardiogramWavesModel> {
    mapFrom(param: ElectrocardiogramWavesEntity): ElectrocardiogramRhythmModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            error:param.error
        };
    }
    mapTo(param: ElectrocardiogramRhythmModel): ElectrocardiogramWavesEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            error:param.error
        }
    }
}